// eslint-disable-next-line boundaries/no-unknown-files
import React, { useEffect, useState } from 'react';
// Компоненты MUI для построения UI
import {
  Alert, AlertTitle, Box, Button, IconButton, TextField, Tooltip
} from '@mui/material';
import PropTypes, { shape } from "prop-types";
// Иконка мессенджера MAX
import MaxIcon from '../../../assets/icons/MaxIcon';
// Стили панели
import style from './MaxPanel.module.css';
import {
  appUserSettingsResourceType
} from "../../../entities/account/appUserSettingsResource/redux/appUserSettingsResource.slice";
// Конфиг с именем бота MAX
import config from "../../../shared/api/config";

// Генерирует случайный токен из 16 символов (буквы + цифры)
function generateToken() {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let token = '';

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < 16; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    token += characters.charAt(randomIndex);
  }

  return token;
}

// Панель управления токеном для чат-бота Max
function MaxPanel({
  data,
  patchAppUserSettingsResourceParams,
  postAppUserSettingsResourceParams,
  idUser
}) {
  const [isEdit, setIsEdit] = useState(false);
  const [dataAppUserSettingsResourceId, setDataAppUserSettingsResourceId] = useState(null);
  const [isErr, setErr] = useState(false);
  const [isCorrect, setIsCorrect] = useState(false);

  // Ищем настройку с group='max' в данных пользователя
  useEffect(() => {
    const userSettings = data?.dataAppUserSettingsResourceId?.data
      ?.find((item) => item.group === 'max');
    if (userSettings) {
      setDataAppUserSettingsResourceId(userSettings);
    } else {
      setDataAppUserSettingsResourceId({});
    }
  }, [data]);

  // Сохраняет или обновляет токен Max через бэкенд
  const handleAppUserSettings = () => {
    const newData = JSON.parse(JSON.stringify(dataAppUserSettingsResourceId));
    newData.value = generateToken();

    if (dataAppUserSettingsResourceId?.value) {
      // Обновляем существующую настройку
      patchAppUserSettingsResourceParams({
        id: newData.appUserSettingId,
        body: { ...newData, name: "max.sec_token" }
      }).then((e) => {
        if (e?.error) {
          setErr(true);
        } else {
          setIsCorrect(true);
          setIsEdit(false);
        }
      });
    } else {
      // Создаём новую настройку
      const postData = {
        group: "max",
        name: "max.sec_token",
        value: newData.value,
        valuelist: "",
        orderNum: 2,
        type: {
          settingId: 3,
          name: "string"
        },
        user: {
          appUserId: idUser,
          firstName: null,
          lastName: null,
          phone: null,
          isBot: null,
          isCompanyAdmin: null,
          isBillAdmin: null,
          isUserAdmin: null,
          isPlanAdmin: null,
          company: null,
          user: null
        }
      };
      postAppUserSettingsResourceParams({
        body: postData
      }).then((e) => {
        if (e?.error) {
          setErr(true);
        } else {
          setIsCorrect(true);
          setIsEdit(false);
        }
      });
    }
  };

  // Открывает Max с переданным токеном через deep link
  const handleOpenMax = () => {
    const token = dataAppUserSettingsResourceId?.value;
    if (token) {
      window.open(`https://max.ru/${config.maxBotName}?start=${token}`, '_blank');
    }
  };

  // Рендер: поле токена + кнопка deep link + алерты + кнопки управления
  return (
    <Box className={style.MaxPanel}>
      <Box sx={{ display: 'flex', gap: '10px', alignItems: 'flex-end', width: '100%' }}>
        <TextField
          disabled
          value={dataAppUserSettingsResourceId?.value || ''}
          sx={{ flex: 1 }}
          label="токен Max бота"
          variant="standard"
        />
        {dataAppUserSettingsResourceId?.value && (
          <Tooltip title="Открыть в Max">
            <IconButton onClick={handleOpenMax} color="primary">
              <MaxIcon sx={{ width: '32px', height: '32px' }} />
            </IconButton>
          </Tooltip>
        )}
      </Box>
      {!isErr && isCorrect
            && (
            <Alert sx={{ width: "100%" }} severity="success">
              <AlertTitle>Успешно</AlertTitle>
              Токен Max успешно сохранен
            </Alert>
            )}
      {isErr
            && (
            <Alert sx={{ width: "100%" }} severity="error">
              <AlertTitle>Ошибка</AlertTitle>
              Произошла ошибка
            </Alert>
            )}

      <Box className={style.buttonsPanel}>
        {isEdit && (
          <Button
            onClick={handleAppUserSettings}
            variant="contained"
          >
            Сгенерировать новый токен
          </Button>
        )}
        {!isEdit && <Button onClick={() => { setIsEdit(true); }} variant="contained">Редактировать</Button>}
        {isEdit && <Button onClick={() => { setIsEdit(false); }} variant="contained">Отмена</Button>}
      </Box>
    </Box>
  );
}

MaxPanel.propTypes = {
  data: PropTypes.shape({
    dataAppUserSettingsResourceId: shape({
      data: PropTypes.arrayOf(PropTypes.shape(appUserSettingsResourceType))
    })
  }),
  patchAppUserSettingsResourceParams: PropTypes.func.isRequired,
  postAppUserSettingsResourceParams: PropTypes.func.isRequired,
  idUser: PropTypes.number.isRequired
};

MaxPanel.defaultProps = {
  data: null,
};

export default MaxPanel;